var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.274292,
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_290_351",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_290_351",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEAUlEQVR4nO2cO2gUQRjHf74SRFFERTQxqKB2NrHQysZGULHQwsZKfL86C21sJG1QRFEELQQ1aCG+EKxs4qOyMDaCaKFg1JxvTDyZMIEQ7vZubmd2N7P/H3wQAnvzzf8/Ozc73+yBEEIIIYQQQohatAEbgFPAE+An8Bm4CnTUvEKkYhqwFjgOPAR+ANU68Q5YnK45YVgB7AFuAIMJgteKM6OfIJwwo3YHcAF46yj4xPgITHFrvnwstIL3As9TCl4r1uTdwaIxC9gI9FjBRwKIPj6OUXKmA932i/MR8Cew4BPjDiVcqXRbwU3nKxkLPjFM+zMo0Urlc86C14r1RMZyYDdwDfiQsZgjLbR5kknOImAncAl4k8MIHgDOAduB+cBs4IXD9Y+ZZMwFttql4UvgX8aCm6fYK8AuoDNhNXUW+N3E5/0CZlJgZtql4WmgHxjOWPBPwE1gP7DKMfcFdrD8atCG6V8hVyqPmki+6jl+2HaP2zymeujT4wZtmsFVmJXKl4wF/2sfunrsSGwP0L8TDXIwd3bmgu+yeyrvc1ipPLffIWabYU4G/V3XICczrc7LIA8hhBBCCCFE5CwF+gpQ9KhOgjAa3QZW+xTf9ZiGgtGCkdEuNWbkS1Ba0sDsh6VG0w4tD8AhHwZo9JNKAxlAvoNIBiADSj2Npcalsb3Ez76iGtBvX2SInXbgadEM6C/ZSwqLHUxITTPTThlG/kTabN9zNyBLuoDDwAN7iu27jQH7v0O+Hv8dKIUBHfbUxXCTJyXMFsCyjHKL3oBtwDfHlUfVbqGYk2yhidqAoynfbDHXHgmcY7QGbPP0WtFI4DshSgM6W5x2kqajJYFyjdKAyx7FH4uLgXKNzoCuQMfWhxPeAYjegPE1ZRO3EmqmhwOIPxYHPeQXQp+gDdSrKQ/WGZH3Axpw10N+vvUJ3kCfY830dUADBjzk51uf4A1UHGumlYAGVDzk51uf4A0kdfBrwQ34moE+wRu4nXBtXwGmINf8fOsTvIHVdd5qHwRWFuBL2DU/3/pk0sBS+4U2ZON6wgrjUEADDnjIL4Q++TZQQ4zhQG9QlvZBzJVLAQw4HyjXKA3o8LwaGgpYs47SAMMmT1OR2Y7eQjiiNQBbTElbkDF7SyGJ2gBsMaXS4rSzmfBEb8DYLx722pVMM6P+aobnlEphwBiddkv5HvDKVs2+2b/v2nV+iKVmoQ3YV9KDWe1NnhNNTTPz7dOSHU1c4vDjr6mpOpjQVpKR/8xBl9S4rDx0PJ18DVAgA6oFGwi6A5ABuY/C6mS+A/SiNi2L30xNuSFJNVMFiRqYylpq6tVMFTT8lV5v2yLja6YSnkQNXGvKQgghhBBCCCGEEEIIIYQgbv4DaLcS9mOeih0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.7a1cf8e083b1fa924558ec39e5cbf950.svg";
export { ForwardRef as ReactComponent };